(function(){
  var timer;
  Pegasus.AutoSaveController = Em.Controller.extend({
    needs: ['frameCommManager'],
    isError: false,
    isStandalone: function(){
      return window === window.parent;
    }.property(),
    isCurrent: function(){
      return this.get('lastVersion') === Em.get(Pegasus.CommandManager, 'instance.version');
    }.property('lastVersion', 'Pegasus.CommandManager.instance.version'),
    updateLastSaved: function(){
      this.set('isError', false);
      Em.propertyDidChange(this, 'needsLastSaveUpdate');
    },
    lastSaved: function(){
      return Pegasus.Helpers.strftime( new Date(), '%l:%M %P').toUpperCase();
    }.property('needsLastSaveUpdate'),
    lastVersion: 0,
    init: function(){
      this._super();
      Em.run.cancel(timer);
      timer = Em.run.later( this, 'saveSnapshot', 60000 * 3);
    },
    clearTimer: function(){
      Em.run.cancel(timer);
    },
    saveSnapshot: function(force){
      try {
        if ( force || this.get('isError') || ! this.get('isCurrent') ) {
          this.set('lastVersion', Em.get(Pegasus.CommandManager, 'instance.version'));
          var translation = Em.I18n.t('g.saving');
          var mask = $('.saving-mask').length ?
            $('.saving-mask') :
            $('<div class="saving-mask"><div class="loading-wrapper"><div class="loading show">'+translation+'...</div></div></div>');
          mask.appendTo('body');

          Pegasus.IOManager.generateOutput(true, function(result){
            Em.run( this.get('controllers.frameCommManager'), 'requestSaveSnapshot', result );
          }.bind(this));

          return true;
        }
      }catch(e){} finally {
        Em.run.cancel(timer);
        timer = Em.run.later( this, 'saveSnapshot', 60000 * 3);
      }

      return false;
    }
  });
})();
